




































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import LoginForm from './components/LoginForm/index.vue'
import expand from './components/expand.vue'
import circular from './components/circular.vue'
import scale from './components/scale.vue'
import { splitArr } from '@/utils/tool'
let vm = null

// 大9图
const bigFile = require.context('./images/partner/big', true, /\.(png|jpe?g|gif|svg)(\?.*)?$/)
const bigImages: Array<any> = []
bigFile.keys().forEach(key => {
  const name = key.replace(/^\.\//, '')
  bigImages.push({
    img: require(`./images/partner/big/${name}`)
  })
})

// 小无限图
const smallFile = require.context('./images/partner/small', true, /\.(png|jpe?g|gif|svg)(\?.*)?$/)
const smallImages: Array<any> = []
smallFile.keys().forEach(key => {
  const name = key.replace(/^\.\//, '')
  smallImages.push({
    img: require(`./images/partner/small/${name}`)
  })
})
// const scrollWidth: string = -(smallImages.length * 170 / 10) + '%'

@Component({
  name: 'Login',
  components: {
    swiper: Swiper,
    'swiper-slide': SwiperSlide,
    LoginForm,
    expand,
    circular,
    scale
  }
})

export default class Login extends Vue {
  private height = String(window.innerHeight)
  private bannerList = [
    innerWidth <= 480 ? 'http://qnimg.zowoyoo.com/img/84826/1623828994277.jpg' : 'http://qnimg.zowoyoo.com/img/84826/1623828939507.jpg',
    innerWidth <= 480 ? 'http://qnimg.zowoyoo.com/img/84826/1623829101581.jpg' : 'http://qnimg.zowoyoo.com/img/84826/1623829080772.jpg',
    innerWidth <= 480 ? 'http://qnimg.zowoyoo.com/img/84826/1623829147769.jpg' : 'http://qnimg.zowoyoo.com/img/84826/1623829121514.jpg'
  ]

  private openLogin = false // 点击打开登录
  private isPlay = false
  private imgSwiper: Array<any> = smallImages
  private peoplesList: Array<any> = bigImages
  // [
  //   {
  //     img: require('./images/partner/big/1.jpg'),
  //     title: '融创文旅集团',
  //     desc: '使用情况：巧用自我游平台多站点功能，从上而下管理、运营多地方乐园产品、活动情况，达成集团和各大乐园信息的高度统一、渠道资源共享。'
  //   },
  //   {
  //     img: require('./images/partner/big/2.jpg'),
  //     title: '广东省旅游控股集团有限公司',
  //     desc: '利用自我游全民营销功能，7天时间内由上而下快速将集团八千名员工发展为产品分销人员，并善用直播功能，开展“BOSS直播带货”，让2020年的“疫情寒冬”化为“暖春”。'
  //   },
  //   {
  //     img: require('./images/partner/big/3.jpg'),
  //     title: '旅悦集团',
  //     desc: '使用情况：通过平台运营和分发能力的加持，全网上千家公众号媒体平台自发分销花筑·心悦卡旅悦集团产品营销和宣传零成本全网覆盖。5天销售1万间夜库存。'
  //   },
  //   {
  //     img: require('./images/partner/big/4.jpg'),
  //     title: 'JTR web',
  //     desc: '使用情况：自我游强大并灵活的API接口，为JTRweb打通日本全线下景区票务系统，实现电子票务在日本的有效流通，解决日本原单一纸质票的局面。'
  //   },
  //   {
  //     img: require('./images/partner/big/5.jpg'),
  //     title: '海昌（中国）集团',
  //     desc: '使用情况：运营自我游体系6000家全国商户渠道优势资源，在短时间内实现品宣、营收的快速提升。'
  //   },
  //   {
  //     img: require('./images/partner/big/6.jpg'),
  //     title: '森林海温泉酒店度假酒店',
  //     desc: '使用情况：使用预售板块，开售当天产品售罄，营收13万'
  //   },
  //   {
  //     img: require('./images/partner/big/7.jpg'),
  //     title: '广东漫享时光国际旅行社',
  //     desc: '2020年4月份，逆风前行，采用预售和产品打包功能，将10个酒店的产品打包成一个产品进行预售抢购。收获两个拳头产品；14天售罄47000套房；7天售罄12000套'
  //   },
  //   {
  //     img: require('./images/partner/big/8.jpg'),
  //     title: '广州走着瞧网络科技有限公司',
  //     desc: '巧妙运用平台任务营销工具2020年公众号涨粉100+万名'
  //   }
  // ]

  private innerWidth = window.innerWidth
  private timer = 0
  private activeIndex = 0
  private once = 0
  // 轮播图配置
  private swiperOptions = {
    initialSlide: 0, // 初始化索引，测试用
    noSwiping: false,
    updateOnWindowResize: true, // 默认当窗口(window) 尺寸发生变化时，比如屏幕旋转，Swiper会更新和重新计算
    width: window.innerWidth, // 设置宽度为全屏
    height: window.innerHeight, // 你的slide高度
    observer: true, // 修改swiper自己或子元素时，自动初始化swiper
    observeParents: true, // 修改swiper的父元素时，自动初始化swiper
    direction: 'vertical',
    mousewheel: true,
    allowTouchMove: true,
    preventClicksPropagation: true, // 阻止click冒泡。拖动Swiper时阻止click事件。
    on: {
      slideChange: function () {
        (vm as any).activeIndex = (this as any).activeIndex
        if ((vm as any).activeIndex === 2) {
          (vm as any).mouseLeave()
        } else {
          (vm as any).mouseOver()
        }
        // 切换屏幕停止视频播放
        if ((vm as any).activeIndex !== 1) {
          (vm as any).isPlay = false as boolean
          if ((vm as any).$refs.video) ((vm as any).$refs.video as HTMLVideoElement).pause()
        }
      }
    }
  }

  // private locationSearch = ''

  get list () {
    if (this.innerWidth > 480) {
      this.peoplesList.pop()
    }
    return splitArr(this.peoplesList, this.innerWidth <= 480 ? 3 : 4)
  }

  created () {
    vm = this as any
  }

  // 产品要求：鼠标移入第一屏，不阻止轮播图滑动
  continueSwiper (): void {
    (this.$refs.carousel as any).handleMouseEnter = () => {
      console.log('重写鼠标事件')
    }
  }

  // 第三屏鼠标移出事件
  mouseOver () {
    if (innerWidth <= 480) return
    this.once = 0
    clearInterval(this.timer)
  }

  // 第三屏鼠标移入事件
  mouseLeave () {
    if (innerWidth <= 480) return
    this.openTimer()
  }

  // 第三屏，每隔2秒切换动画
  openTimer () {
    if (this.activeIndex !== 2) {
      this.once = 0
      clearInterval(this.timer)
      return
    }
    this.timer = setInterval(() => {
      this.once++
      if (this.once > 3) {
        this.once = 1
      }
      console.log(this.once)
    }, 2000)
  }

  // 第二屏开始/暂停播放
  plays () {
    this.isPlay = !this.isPlay
    if (this.$refs.video) {
      if (this.isPlay) {
        (this.$refs.video as HTMLVideoElement).play()
      } else {
        (this.$refs.video as HTMLVideoElement).pause()
      }
    }
  }

  pause () {
    if (this.isPlay) this.plays()
  }

  pauseAnimation () {
    (this.$refs.introduceBoxScroll as HTMLDivElement).style.animationPlayState = 'paused'
  }

  playAnimation () {
    (this.$refs.introduceBoxScroll as HTMLDivElement).style.animationPlayState = 'running'
  }

  // 点击下一屏
  slideNext (): void {
    (this.$refs.swiper as any).swiperInstance.slideNext()
  }
}
